var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 801,
    height: 265,
    viewBox: "0 0 801 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.472 1V62.3471L119.68 71.1382L128.472 79.9294V128.472H1V1H128.472ZM83.9426 96.5562V83.9427H71.1381V96.5562H83.9426ZM83.9426 58.3337V45.7203H71.1381V58.3337H83.9426Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.176 1H263.648V128.472H206.315V83.9427H193.51V128.472H136.176V1ZM206.315 58.3337V45.7203H193.51V58.3337H206.315Z",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.472 193.51H83.9426V180.897H71.1381V219.119H83.9426V206.315H128.472V263.649H1V136.177H128.472V193.51Z",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.817 135.79H263.15V263.261H205.817V237.843H193.012V263.261H135.679V135.79H193.012V180.51H205.817V135.79Z",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.44 146.662H531.453V264H270L270 1L387.44 1.00002V146.662Z",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M394.777 1.00002H531.453L531.453 139.581H394.776L394.777 1.00002ZM469.979 78.1605V64.4433H456.25V78.1605H469.979Z",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M682.405 92.5571V144.596H708.668V118.381H800V264H538.547V1H800V92.5571H682.405Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/LOGO-main.9ba955f5f5bb713d9660f3e7a58f68bf.svg";
export { ForwardRef as ReactComponent };